import './bootstrap-styles.scss'
import { generateClasses } from '@formkit/themes'

const buttons = {
  outer: '$reset mt-3',
  input: '$reset btn btn-primary formkit-input',
}

const options = {
  outer: 'mt-3',
  label: 'ml-2',
  fieldset: 'formkit-fieldset',
  help: '',
}

const base = {
  global: {
    input: '$reset form-control',
    label: 'form-label',
    help: 'form-text',
    prefix: 'input-group-prepend',
    form: '',
    inner: '',
    wrapper: '',
    messages: '',
    message: '',
    actions: '',
    radio: '',
  },
  text: {
    prefix: 'input-group-prepend',
  },
  select: {
    input: 'custom-select',
  },
  file: {
    input: '$reset formkit-input form-control-file',
  },
  checkbox: options,
  radio: options,
  color: {
    input: 'formkit-input',
  },
  button: buttons,
  submit: buttons,
  taglist: {
    tags: 'form-control',
    input: '$reset formkit-input',
  },
  'multi-step': {
    wrapper: '$reset formkit-wrapper',
    steps: 'p-0 border-0',
  },
}

const vertical = { ...base }

const horizontal = {
  ...base,
  global: {
    ...base.global,
    form: `${base.global.form} formkit-horizontal`,
    label: `${base.global.label} col-form-label col-md-4`,
    inner: `${base.global.inner} col-md-8`,
    wrapper: `${base.global.wrapper} form-row`,
    help: `${base.global.help} col-md-8 offset-md-4`,
    messages: `${base.global.messages} form-row`,
    message: `${base.global.message} col-md-8 offset-md-4`,
    actions: `${base.global.actions} col-md-8 offset-md-4 d-flex justify-content-end`,
  },
  submit: {
    ...base.button,
    outer: `${buttons.outer} formkit-outer`,
  },
  radio: {
    ...base.radio,
    outer: `${base.radio.outer} form-row`,
    inner: '$reset formkit-inner ml-0',
    fieldset: `${base.radio.fieldset} col-md-12 pl-3 pr-3`,
    help: `${base.radio.help} ml-0`,
  },
  checkbox: {
    ...base.checkbox,
    inner: '$reset formkit-inner',
  },
  // The gsg-upload input should always be vertical, even if we're using
  // the horizontal classes.
  'gsg-upload': {
    wrapper: '$reset formkit-wrapper',
    label: '$reset formkit-label form-label',
    inner: '$reset formkit-inner',
  },
  // The repeater elements lack labels, so we shouldn't reserve space
  // for that label.
  repeater: {
    inner: '$reset formkit-inner',
  },
}

/**
 * Bootstrap theme for FormKit
 */
export default {
  /**
   * A Bootstrap FormKit theme, "vertical" variation, where labels are placed
   * vertically above inputs
   */
  verticalClasses: generateClasses(vertical),

  /**
   * A Bootstrap FormKit theme, "horizontal" variation, where labels are placed in
   * columns to the left of inputs
   */
  horizontalClasses: generateClasses(horizontal),
}
